import { useToast } from "@/hooks/use-toast";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast";
import { useEffect } from "react";

export function Toaster() {
  const { toasts, dismiss } = useToast();

  // Schließe Toasts beim Klick außerhalb
  useEffect(() => {
    if (toasts.length === 0) return;

    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Element;
      // Prüfe, ob der Klick außerhalb aller Toast-Elemente war
      const isClickOnToast = target.closest("[data-radix-toast-root]");
      const isClickOnViewport = target.closest("[data-radix-toast-viewport]");

      if (!isClickOnToast && !isClickOnViewport) {
        // Schließe alle sichtbaren Toasts
        toasts.forEach(toast => {
          if (toast.open) {
            dismiss(toast.id);
          }
        });
      }
    };

    // Verwende mousedown statt click für bessere Responsivität
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [toasts, dismiss]);

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast
            key={id}
            {...props}
            onClick={() => {
              dismiss(id);
            }}
          >
            <div className="grid gap-1 flex-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
